import { filter, keyBy } from 'lodash'
import { FETCH_REVENUES } from './actionTypes'

const initialState = {
  byId: {},
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_REVENUES: {
      const revenues = payload.stands.map(stand => {
        return {
          ...stand,
          menus: filter(payload.menus, menu => menu.standUuid === stand.uuid),
        }
      })

      return {
        ...state,
        byId: keyBy(revenues, 'uuid'),
      }
    }

    default:
      return state
  }
}
